/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';
import { View } from 'backbone.marionette';

import OrderTypes from '@/enums/OrderTypes';

import loadAWPackageInformationView from '../../loaders/AWPackageInformationViewLoader';
import loadLegacyAWPackageInformationView from '../../loaders/LegacyAWPackageInformationViewLoader';
import loadAWPackageAdditionalInformationView from '../../loaders/AWPackageAdditionalInformationViewLoader';
import loadAWPackageSelectOPsView from '../../loaders/AWPackageSelectOPsViewLoader';
import loadAWPackageDeliveryScheduleGridView from '../../loaders/AWPackageDeliveryScheduleGridViewLoader';
import loadAWPackageRemarksView from '../../loaders/AWPackageRemarksViewLoader';
import DeliverySchedulePrintView from '../../../common/DeliverySchedulePrintView/DeliverySchedulePrintView';

import './AWPackagePrintPage.css';

import tmplAWPackagePrintPage from './AWPackagePrintPage.hbs';
const AWPackagePrintPage = View.extend({
  template: tmplAWPackagePrintPage,

  className: 'aw-package-page container-fluid',

  ui: {
    selectedOrdersView: '.selected-orders-print-view',
    deliveryScheduleView: '.delivery-schedule-print-view',
    informationView: '.information-print-view',
    additionalInfoView: '.additional-information-print-view',
    remarksView: '.remarks-print-view'
  },

  regions: {
    selectedOrdersView: '@ui.selectedOrdersView',
    deliveryScheduleView: '@ui.deliveryScheduleView',
    informationView: '@ui.informationView',
    additionalInfoView: '@ui.additionalInfoView',
    remarksView: '@ui.remarksView'
  },

  async onRender() {
    const awPackage = this.model.get('awPackage');
    const awPackageId = awPackage.id;
    const isLegacy = awPackage.isLegacy === '1';
    const isSpecialtyRequirement = awPackage.orderFormTypeId === OrderTypes.SPECIALTY_REQ;

    const [selectedOrdersView, deliveryScheduleGridView, packageInfoView, additionalInfoView, remarksView] =
      await Promise.all([
        loadAWPackageSelectOPsView({ awPackageId, editable: false }),
        loadAWPackageDeliveryScheduleGridView({ awPackageId, editable: false }),
        isLegacy
          ? loadLegacyAWPackageInformationView({ awPackageId, editable: false })
          : loadAWPackageInformationView({ awPackageId, editable: false, toggleContractExtensionCheck: true }),
        isLegacy ? Promise.resolve(null) : loadAWPackageAdditionalInformationView({ awPackageId, editable: false }),
        isLegacy ? Promise.resolve(null) : loadAWPackageRemarksView({ awPackageId, editable: false })
      ]);

    this.selectedOrdersView = selectedOrdersView;
    const deliverySchedules = deliveryScheduleGridView.model.attributes.schedules;

    this.showChildView('selectedOrdersView', selectedOrdersView);
    this.showChildView(
      'deliveryScheduleView',
      new DeliverySchedulePrintView({
        model: new Backbone.Model({
          deliverySchedules,
          isRelocation: false,
          isSpecialtyRequirement
        })
      })
    );
    this.showChildView('informationView', packageInfoView);

    if (!isLegacy) {
      this.showChildView('additionalInfoView', additionalInfoView);
      this.showChildView('remarksView', remarksView);
    }

    window.print();
  }
});

export default AWPackagePrintPage;
